import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PlayerChoiceCount from '../player-choice-count/playerChoiceCount';

import './playerChoiceCounts.css'

export default class PlayerChoiceCounts extends Component {

  constructor(props) {
    super(props);

    this.state = {
      higherCount: props.higherCount,
      lowerCount: props.lowerCount
    };
  }

  componentDidMount() {
    if (this.props.selectedAnswer === 'higher') {
      this.setState({
        higherCount: this.props.higherCount + 1,
        lowerCount: this.props.lowerCount
      });
    }

    if (this.props.selectedAnswer === 'lower') {
      this.setState({
        higherCount: this.props.higherCount,
        lowerCount: this.props.lowerCount + 1
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedAnswer === 'higher') {
      this.setState({
        higherCount: nextProps.higherCount + 1,
        lowerCount: nextProps.lowerCount
      })
      return;
    }

    if (nextProps.selectedAnswer === 'lower') {
      this.setState({
        higherCount: nextProps.higherCount,
        lowerCount: nextProps.lowerCount + 1
      })
      return;
    }
  }

  render() {
    return (
      <div className='player-choices'>
        <PlayerChoiceCount label='higher'
          count={this.state.higherCount}
          selectedAnswer={this.props.selectedAnswer}
          correctAnswer={this.props.correctAnswer}
          answered={this.props.answered} />
        <PlayerChoiceCount label='lower'
          count={this.state.lowerCount}
          selectedAnswer={this.props.selectedAnswer}
          correctAnswer={this.props.correctAnswer}
          answered={this.props.answered} />
      </div>
    );
  }
}

PlayerChoiceCounts.propTypes = {
    higherCount: PropTypes.number,
    lowerCount: PropTypes.number,
    selectedAnswer: PropTypes.string, 
    correctAnswer: PropTypes.string, 
    answered: PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/components/player-choice-counts/playerChoiceCounts.js